module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0067.jpg?v=12752609";